import React from 'react';
import { useApp } from '../context/AppContext';
import { useSubscription } from '../context/SubscriptionContext';

const WARNING_THRESHOLD = 0.9; // Show banner when at or above 90% of limit

const VehicleLimitBanner = ({ onUpgrade }) => {
  const { vehicles } = useApp();
  const { isLiteTier, getVehicleLimit } = useSubscription();

  const limit = getVehicleLimit();
  const activeCount = (vehicles || []).filter((v) => !v.deletedAt).length;
  const atOrAboveThreshold = limit != null && activeCount >= Math.floor(limit * WARNING_THRESHOLD);

  if (!isLiteTier() || limit == null || !atOrAboveThreshold) return null;

  return (
    <div
      role="banner"
      style={{
        padding: '10px 16px',
        background: activeCount >= limit ? '#fef2f2' : '#fffbeb',
        borderBottom: `1px solid ${activeCount >= limit ? '#fecaca' : '#fde68a'}`,
        color: activeCount >= limit ? '#991b1b' : '#92400e',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '8px'
      }}
    >
      <span>
        {activeCount >= limit
          ? `You've reached the ${limit} vehicle limit for Lite. Upgrade to add more.`
          : `Approaching vehicle limit (${activeCount}/${limit}). Upgrade for unlimited vehicles.`}
      </span>
      {typeof onUpgrade === 'function' && (
        <button
          type="button"
          onClick={onUpgrade}
          style={{
            padding: '6px 14px',
            fontSize: '13px',
            fontWeight: 600,
            border: 'none',
            borderRadius: '8px',
            background: 'var(--primary, #4f8df3)',
            color: '#fff',
            cursor: 'pointer'
          }}
        >
          Upgrade
        </button>
      )}
    </div>
  );
};

export default VehicleLimitBanner;
